import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.hooks.usePersonDocumentTypes', {
    bankStatement: 'Bank statement',
    biometricStateId: 'Biometric state ID',
    drivingLicence: 'Driving licence',
    mortgage: 'Mortgage',
    passport: 'Passport',
    proofOfBusinessActivity: 'Proof of business activity',
    proofOfBusinessIdentity: 'Proof of business identity',
    proofOfDirectors: 'Proof of directors',
    proofOfOwners: 'Proof of owners',
    proofOfSourceOfFunds: 'Proof of source of funds',
    residenceId: 'Residence ID',
    stateId: 'State ID',
    supporting: 'Supporting',
    unknown: 'Unknown',
    utilityBill: 'Utility bill',
    visa: 'Visa',
});
